import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';

import { Api } from './api.service';
import { Subscription, SubscriptionPayment, OptionPayment } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class SubscriptionPaymentService {
  constructor(protected http: Api) {
  }

  @Log('green')
  get(id: number): Observable<SubscriptionPayment> {
    return this.http.get(`subscriptionpayment/${id}`);
  }

  @Log('green')
  findAllBySubscription(subscription: Subscription): Observable<SubscriptionPayment[]> {
    const params = new URLSearchParams();
    params.set('subscription_id', String(subscription.id));
    params.set('limit', '1000');
    params.set('sort_field', 'date');
    params.set('sort_order', 'desc');
    return this.http
      .get(`subscriptionpayment`, { search: params })
      .map(res => {
        return res.items;
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/subscription-payment.service.ts